module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"showFantasy":"Vis fantasi"},"en":{"showFantasy":"Show Fantasy"}}')
  delete Component.options._Ctor
}
